<template>
  <Layout>
    <PageHeader :title="title" :items="items"/>
    <Loader :loading="httpSend">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <liberacao-detalhe :solicitacao="solicitacao"></liberacao-detalhe>
              <div class="row">
                <div class="col-md-12">
                  <button @click="relSolicitacao()" type="button"
                          class="btn btn-label mr-3 btn-info">
                    <i class="bx bx-file label-icon"></i>
                    Cartão
                  </button>
                  <button type="button" @click="fechar()" class="btn btn-label btn-light"><i
                      class="bx bx-exit label-icon"></i> Voltar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Loader>
  </Layout>
</template>

<script>
import {required} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader";
import Layout from "@/router/layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import LiberacaoDetalhe from "@/router/views/contribuinte/components/liberacao-detalhe"
import {getSolicitacao} from "@/api/solicitacao/pessoa";
import {impressao} from "@/helps/impressao";
import {setRelSolicitacaoCadastro} from "@/api/relatorio/contribuinte";

export default {
  page: {
    title: "Solicitação",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    LiberacaoDetalhe
  },
  data() {
    return {
      title: "Solicitação",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitações',
          active: true,
        },
      ],
      httpSend: false,
      aprovada: false,
      solicitacao: {
        pessoa: {
          tps_cpf_cnpj: '',
          tps_natureza_juridica: {
            naj_referencia: '',
          },
        },
        economico: {
          tec_contador_proprio: '',
          eco_substituicao: '',
        },
        usuario: {
          pes_nome: ''
        },
        historico_movimentacao: [],
      },
      historico: {
        ceh_codigo: null,
        chm_status: '',
        chm_motivo: '',
        eco_substituicao: null,
      },
    };
  },
  validations: {
    historico: {
      chm_status: {
        required,
      },
      chm_motivo: {
        required,
      },
    },
  },
  created() {
    this.getSocilitacao();
  },
  methods: {
    getSocilitacao() {
      this.httpSend = true;
      getSolicitacao(this.$route.params.tps_hash).then(response => {
        if (response.status) {
          this.solicitacao = response.dados
          if (this.solicitacao.historico_movimentacao && this.solicitacao.historico_movimentacao[0]) {
            this.aprovada = (this.solicitacao.historico_movimentacao[0].chm_status === '9');
          }
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    relSolicitacao() {
      this.httpSend = true;
      impressao(setRelSolicitacaoCadastro(this.$route.params.tps_hash), 'D').catch(error => {
        console.log(error)
      }).finally(() => {
        this.httpSend = false;
      })
    },
    fechar() {
      this.$router.push({name: 'contribuinte-solicitacao'})
    },
  },
};
</script>


